export default function useForm(
  state,
  dispatch,
  propertyName,
  type = "YARD_INFO"
) {
  function handleChange(event) {
    const values = state[propertyName];
    const newValues = {
      ...values,
      [event.target.name]: event.target.value,
    };
    dispatch({ type, payload: newValues });
  }

  return { handleChange };
}

export const EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const URL_REGEX =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,6})?(\/.*)?$/;
